document.addEventListener("DOMContentLoaded", function () {
  ProductList.prototype.afterRender = function () {
    document.dispatchEvent(new Event("reloadQuickBuy"));

    const swatchHTML = `
            <div
                data-product-id="7994138362047"
                data-variant-ids="43772143960255,43772143993023,43772144025791,43772144058559,43772144091327,43772144124095"
                data-size-options="SM,MD,LG,XL,XXL,XXXL"
                data-available-options="true,true,true,true,true,true"
                data-color="Sonic Blue"
                class="color-button Sonic Blue"
                data-imageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-462318.jpg?v=1747236948&width=550"
                data-hoverimageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-106304.jpg?v=1747236949&width=550"
                style="background: #3073B7; background-position: center; background-size: cover;"
                title="Sonic Blue"
                tabindex="0"
            ></div>

            <div
                data-product-id="7994147012799"
                data-variant-ids="43772224438463,43772224471231,43772224503999,43772224536767,43772224569535,43772224602303"
                data-size-options="SM,MD,LG,XL,XXL,XXXL"
                data-available-options="true,true,true,true,true,true"
                data-color="Faded Red"
                class="color-button Faded Red"
                data-imageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-206905.jpg?v=1747236947&width=550"
                data-hoverimageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-666334.jpg?v=1747236948&width=550"
                style="background: #AD5D5D; background-position: center; background-size: cover;"
                title="Faded Red"
                tabindex="0"
            ></div>

            <div
                data-product-id="7994142916799"
                data-variant-ids="43772194783423,43772194816191,43772194848959,43772194881727,43772194914495,43772194947263"
                data-size-options="SM,MD,LG,XL,XXL,XXXL"
                data-available-options="true,true,true,true,true,true"
                data-color="Black Camo"
                class="color-button Black Camo"
                data-imageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-896626.jpg?v=1747236946&width=550"
                data-hoverimageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-904088.jpg?v=1747236946&width=550"
                style="background: #000000; background-position: center; background-size: cover;"
                title="Black Camo"
                tabindex="0"
            ></div>

            <div
                data-product-id="7994141081791"
                data-variant-ids="43772174565567,43772174598335,43772174631103,43772174663871,43772174696639,43772174729407"
                data-size-options="SM,MD,LG,XL,XXL,XXXL"
                data-available-options="true,true,true,true,true,true"
                data-color="Ash Gray"
                class="color-button Ash Gray"
                data-imageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-930611.jpg?v=1747236948&width=550"
                data-hoverimageurl="//greatnesswins.com/cdn/shop/files/core-tech-run-short-385808.jpg?v=1747236948&width=550"
                style="background: #AEB2B5; background-position: center; background-size: cover;"
                title="Ash Gray"
                tabindex="0"
            ></div>`;

    $('[data-product-custom-title="Core Tech Run Short"]').each(function () {
      const swatchesContainer = $(this).find(".swtches-custom-class");
      if (swatchesContainer.children().length === 0) {
        swatchesContainer.append(swatchHTML);
      }
    });
  };

  Filter.prototype.afterRender = function () {
    document.dispatchEvent(new Event("reloadQuickBuy"));
  };

  FilterResult.prototype.afterRender = function () {
    document.dispatchEvent(new Event("reloadQuickBuy"));
  };
});
